/**
 * Created by Julio Perez on 9/29/2016.
 */
import MapPageController from './map-page.controller';

function mapPage(){
    return {
        restrict: "E",
        scope: {
            name: '='
        },
        template: require('./map-page.html'),
        controller: MapPageController,
        controllerAs: 'ctrl'//,
        // link:link
    }

    // function link(scope, element, attrs){




        //
        // // var map = L.map('mapID').setView([51.505, -0.09], 13);
        // var mapID = L.map('mapID',
        //     {
        //         center: [37.5, -122.23],
        //         zoom: 1
        //     });
        //
        // L.tileLayer.provider('Stamen.Watercolor').addTo(mapID);
        // // L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
        //
        // console.log("MAP DIRECTIVE", L);
        //
        // // L.esri.basemapLayer('DarkGray').addTo(map);

    // }
}

export default angular
    .module('map-page.directive', [])
    .directive('mapPage', mapPage)
    .name;



// WEBPACK FOOTER //
// ./src/app/views/map-page/map-page.directive.js